import * as Effects from 'redux-saga/effects'
import { WidgetActions } from '../../reducers/widget/actionNames'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import fetchGoogleHotel from '../../models/Integration/fetchGoogleHotel'
import saveGoogleHotel from '../../models/Integration/saveGoogleHotel'
import saveGoogleHotelStatus from '../../models/Integration/saveGoogleHotelStatus'

function * loadGoogleHotel(action: any) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchGoogleHotel)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchGoogleHotel),
      ),
    ])

    let settings = yield Effects.call(service)

    yield Effects.put({
      settings,
      type: WidgetActions.GoogleHotelAccepted,
    })
  } catch (e) {
    console.error(e)
  }
}

function* setGoogleHotel(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveGoogleHotel)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, saveGoogleHotel),
      ),
    ])

    yield Effects.call(service, action.status)

    yield Effects.put({type: WidgetActions.FetchGoogleHotel})
  } catch (e) {
    console.error(e)
  }
}

function* setGoogleHotelStatus(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveGoogleHotelStatus)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, saveGoogleHotelStatus),
      ),
    ])

    yield Effects.call(service, action.status)

    yield Effects.put({type: WidgetActions.FetchGoogleHotel})
  } catch (e) {
    console.error(e)
  }
}

export default function* () {
  yield Effects.takeEvery(WidgetActions.FetchGoogleHotel, loadGoogleHotel)
  yield Effects.takeEvery(WidgetActions.SaveGoogleHotel, setGoogleHotel)
  yield Effects.debounce(2000, WidgetActions.SaveGoogleHotelStatus, setGoogleHotelStatus)
}